import { render, staticRenderFns } from "./MoleculeTeam.vue?vue&type=template&id=25668cca&scoped=true&"
import script from "./MoleculeTeam.vue?vue&type=script&lang=js&"
export * from "./MoleculeTeam.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeTeam.vue?vue&type=style&index=0&id=25668cca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25668cca",
  null
  
)

export default component.exports